export const STATUS_TYPES = {
  ACTIVE: "active",
  DRAFT: "draft",
  REJECT: "reject",
  REMOVED: "removed",
  ERROR: "error",
  FORMATION: "formation",
  LOADING: "loading",
  CONFIRM: "confirm",
};

export const DATA_STATUS_TYPES = {
  ND: "ND",
  DASH: " - ",
};

export const DATA_STAFF_COUNT = [
  // "StandardCountSum",
  // "FactCountSum",
  // "PercentCountSum",
  "fact",
  "standard",
  "compliance",
];

export const DATA_STAFF_TRAINING = ["FactTrainingSum", "PercentTrainingSum"];

export const DATA_STAFF_REQUIRED = ["PersonRequiredSum", "PercentRequiredSum"];

export const DATA_STAFF_CERTIFICATED = [
  "PersonCertificatedSum",
  "PercentCertificatedSum",
];
